import { render } from "./CtaSection.vue?vue&type=template&id=5afbf8ca&scoped=true"
const script = {}

import "./CtaSection.vue?vue&type=style&index=0&id=5afbf8ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afbf8ca"]])

export default __exports__